import styled from 'styled-components';
import { BasketPaymentDetailsStyled } from '../BasketPaymentDetailsStyled';
import { rem } from 'polished';

export const BasketPaymentDetailsAP = styled(BasketPaymentDetailsStyled)``;
